import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from 'material-ui/styles';
import Grid from 'material-ui/Grid';
import TextField from 'material-ui/TextField';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import ExpansionPanel, { ExpansionPanelSummary, ExpansionPanelDetails } from 'material-ui/ExpansionPanel';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';
import IconButton from 'material-ui/IconButton';
import DeleteIcon from 'material-ui-icons/Delete';
import ModeEditIcon from 'material-ui-icons/ModeEdit';

import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table';
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle } from 'material-ui/Dialog';

class ControlDimensions extends Component {
	state = {
		dimensionDialogOpen: false,
		mode: 'add', // 'add' or 'update'
		form: {
			fields: {
				dimensionName: {
					value: '',
					isValid: false,
					isTouched: false
				},
				dimensionValue: {
					value: '',
					isValid: false,
					isTouched: false
				}
			},
			isValid: false
		}
	}

	handleAddDimensionDialog = () => {
		this.setState({
			dimensionDialogOpen: true,
			mode: 'add'
		});
	}

	handleUpdateDimensionDialog = (name, value) => {
		this.setState({
			dimensionDialogOpen: true,
			mode: 'update',
			form: {
				fields: {
					dimensionName: {
						...this.state.form.fields.dimensionName,
						value: name,
						isValid: true
					},
					dimensionValue: {
						...this.state.form.fields.dimensionValue,
						value: value,
						isValid: true
					}
				},
				isValid: true
			}
		});
	}

	handleCloseDimensionDialog = () => {
		this.setState({
			dimensionDialogOpen: false
		});
		this.resetForm();
	}

	resetForm = () => {
		this.setState({
			form: {
				fields: {
					dimensionName: {
						value: '',
						isValid: false,
						isTouched: false
					},
					dimensionValue: {
						value: '',
						isValid: false,
						isTouched: false
					}
				},
				isValid: false
			}
		});
	}

	validateInput = (value) => {
		let isValid = true;

		isValid = value.trim() !== '' && isValid;
		isValid = /[^a-zA-Z]/.test(value) === false && isValid;

		return isValid;
	}

	inputChangeHandler = (event) => {
		this.setState({
			form: {
				...this.state.form,
				fields: {
					...this.state.form.fields,
					[event.target.name]: {
						...this.state.form.fields[event.target.name],
						value: event.target.value,
						isValid: this.validateInput(event.target.value),
						isTouched: true
					}
				}
			}
		}, () => {
			let formIsValid = true;
			for (let formField in this.state.form.fields) {
				formIsValid = this.state.form.fields[formField].isValid && formIsValid;
			}

			this.setState({
				form: {
					...this.state.form,
					isValid: formIsValid
				}
			});
		});
	}

	handleAddDimension = (event) => {
		event.preventDefault();
		this.props.change(this.state.form.fields.dimensionName.value, this.state.form.fields.dimensionValue.value);
		this.handleCloseDimensionDialog();
	}

	handleRemoveDimension = (dimension) => {
		this.props.change(dimension);
	}

	render() {
		const { classes } = this.props;

		return (
			<ExpansionPanel>
				<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
					<Typography className={classes.heading}>Dimensions</Typography>
				</ExpansionPanelSummary>
				<ExpansionPanelDetails>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>Dimension Name</TableCell>
								<TableCell>Dimension Value</TableCell>
								<TableCell numeric>
									<Button onClick={this.handleAddDimensionDialog}>Add Dimension</Button>
								</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{Object.keys(this.props.dimensions).map((DimensionName, index) => (
								<TableRow key={index}>
									<TableCell>{DimensionName}</TableCell>
									<TableCell>{this.props.dimensions[DimensionName]}</TableCell>
									<TableCell numeric>
										<IconButton onClick={() => this.handleUpdateDimensionDialog(DimensionName, this.props.dimensions[DimensionName])}>
											<ModeEditIcon />
										</IconButton>
										<IconButton onClick={() => this.handleRemoveDimension(DimensionName)}>
											<DeleteIcon />
										</IconButton>
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>

					<Dialog open={this.state.dimensionDialogOpen} onClose={this.handleCloseDimensionDialog} disableBackdropClick disableEscapeKeyDown>
						<form onSubmit={this.handleAddDimension}>
							<DialogTitle id="form-dialog-title">Dimension</DialogTitle>
							<DialogContent>
								<DialogContentText>To {this.state.mode} a dimension, please enter a dimension name and a dimension value.</DialogContentText>
								<Grid container>
									<Grid item xs={6}>
										<TextField
											autoFocus
											margin="dense"
											name="dimensionName"
											value={this.state.form.fields.dimensionName.value}
											error={!this.state.form.fields.dimensionName.isValid && this.state.form.fields.dimensionName.isTouched}
											label="Dimension Name"
											fullWidth
											onChange={this.inputChangeHandler}
										/>
									</Grid>
									<Grid item xs={6}>
										<TextField
											margin="dense"
											name="dimensionValue"
											value={this.state.form.fields.dimensionValue.value}
											error={!this.state.form.fields.dimensionValue.isValid && this.state.form.fields.dimensionValue.isTouched}
											label="Dimension Value"
											fullWidth
											onChange={this.inputChangeHandler}
										/>
									</Grid>
								</Grid>
							</DialogContent>
							<DialogActions>
								<Button onClick={this.handleCloseDimensionDialog} color="primary">Cancel</Button>
								<Button type="submit" color="primary" disabled={!this.state.form.isValid}>{this.state.mode} Dimension</Button>
							</DialogActions>
						</form>
					</Dialog>
				</ExpansionPanelDetails>
			</ExpansionPanel>
		);
	}
};

ControlDimensions.propTypes = {
	classes: PropTypes.object.isRequired,
	dimensions: PropTypes.object.isRequired
};

const styles = theme => ({
	heading: {
		fontSize: theme.typography.pxToRem(15),
		fontWeight: theme.typography.fontWeightRegular
	}
});

export default withStyles(styles)(ControlDimensions);



// WEBPACK FOOTER //
// ./src/components/SiteGenerator/ControlDimensions.js